import { UPDATE_TYPES } from "@clipboard-health/contract-backend-main";
import { Button, MenuItem, Stack, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

interface ProfileChangeLogsFilterBarProps {
  emailInput: string;
  updatedFieldKeyInput: string;
  updateType: UPDATE_TYPES | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  isAnyFilterActive: boolean;
  onEmailInputChange: (value: string) => void;
  onUpdatedFieldKeyInputChange: (value: string) => void;
  onUpdateTypeChange: (value: UPDATE_TYPES | undefined) => void;
  onStartDateChange: (value: Date | undefined) => void;
  onEndDateChange: (value: Date | undefined) => void;
  onClear: () => void;
}

const ANY_UPDATE_TYPE = "ALL";

export function ProfileChangeLogsFilterBar(props: ProfileChangeLogsFilterBarProps) {
  const {
    emailInput,
    updatedFieldKeyInput,
    updateType,
    startDate,
    endDate,
    isAnyFilterActive,
    onEmailInputChange,
    onUpdatedFieldKeyInputChange,
    onUpdateTypeChange,
    onStartDateChange,
    onEndDateChange,
    onClear,
  } = props;

  return (
    <Stack spacing={2} sx={{ marginBottom: 1.5 }}>
      <Stack direction="row" spacing={4} flexWrap="wrap" useFlexGap alignItems="center">
        <TextField
          size="small"
          label="Performed By (Email)"
          placeholder="contains…"
          value={emailInput}
          onChange={(event) => onEmailInputChange(event.target.value)}
          sx={{ minWidth: 240 }}
        />

        <TextField
          size="small"
          label="Updated Field Name"
          placeholder="contains…"
          value={updatedFieldKeyInput}
          onChange={(event) => onUpdatedFieldKeyInputChange(event.target.value)}
          sx={{ minWidth: 240 }}
        />

        <TextField
          select
          size="small"
          label="Update Type"
          value={updateType ?? ANY_UPDATE_TYPE}
          onChange={(event) => {
            const next = event.target.value;
            onUpdateTypeChange(next === ANY_UPDATE_TYPE ? undefined : (next as UPDATE_TYPES));
          }}
          sx={{ minWidth: 200 }}
        >
          <MenuItem value={ANY_UPDATE_TYPE}>Any</MenuItem>
          {Object.values(UPDATE_TYPES).map((value) => (
            <MenuItem key={value} value={value}>
              {value}
            </MenuItem>
          ))}
        </TextField>
      </Stack>

      <Stack direction="row" spacing={4} flexWrap="wrap" useFlexGap alignItems="center">
        <DatePicker
          label="Start Date"
          value={startDate ?? null}
          onAccept={(value) => onStartDateChange(value ?? undefined)}
          maxDate={endDate ?? undefined}
          slotProps={{
            textField: { size: "small", sx: { width: 200 } },
            field: { clearable: true, onClear: () => onStartDateChange(undefined) },
          }}
        />

        <DatePicker
          label="End Date"
          value={endDate ?? null}
          onAccept={(value) => onEndDateChange(value ?? undefined)}
          minDate={startDate ?? undefined}
          slotProps={{
            textField: { size: "small", sx: { width: 200 } },
            field: { clearable: true, onClear: () => onEndDateChange(undefined) },
          }}
        />

        <Button variant="text" onClick={onClear} disabled={!isAnyFilterActive}>
          Clear filters
        </Button>
      </Stack>
    </Stack>
  );
}
